// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"afac1ba9","455":"14a6c8e8","977":"ee27e398"}[chunkId] + ".chunk.js";
};